/**
 * 商品画像の「名前」のプリセット選択肢。
 *
 * 名前は DB 上は text のままで、ここは入力 UI の選択肢を定義するだけ。
 * 将来パートナー別/組織別マスター (案C) に移行する場合は、このファイルを
 * API 取得に差し替える (保存形式は変わらないためデータ移行は不要)。
 */
export const IMAGE_NAME_PRESETS = [
  '商品画像',
  '利用シーン画像',
  'ロゴ',
  'アイコン',
  '画面キャプチャ',
  '効果・効能',
  '寸法図',
  '注意書き',
] as const;

export function isImageNamePreset(name: string): boolean {
  return (IMAGE_NAME_PRESETS as readonly string[]).includes(name);
}
